import IPagination from 'interfaces/Pagination';

import { ReduxStore } from 'store/types';

function getAllPagination(state: ReduxStore): IPagination {
  return state.intervention.getAll.config.pagination;
}

export default getAllPagination;
